import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validator function to check if a form control's value contains HTML tags.
 * @param control - The form control to validate.
 * @returns A validation error object if HTML tags are found, otherwise null.
 */
export function noHtmlValidator(control: AbstractControl): ValidationErrors | null {
  const htmlTagPattern = /<\/?[\w\s="/.':;#-\/\?]+>/gi;
  const hasHtml = htmlTagPattern.test(control.value);
  return hasHtml ? { htmlNotAllowed: 'htmlNotAllowed' } : null;
}

/**
 * Validator function to check if a string contains HTML tags.
 * @param title - The string to validate.
 * @returns A validation error object if HTML tags are found, otherwise null.
 */
export function noHtmlValidatorString(title: string): ValidationErrors | null {
  const htmlTagPattern = /<\/?[\w\s="/.':;#-\/\?]+>/gi;
  const hasHtml = htmlTagPattern.test(title);
  return hasHtml ? { htmlNotAllowed: 'htmlNotAllowed' } : null;
}
